module.exports = __webpack_public_path__ + "files/9f682df498753f2c5aac21c73d975b82.png";